import { IConfigurations } from '@epicuro-next/platform/configuration';

export const NAMESPACE_NEWS_FEED = 'newsfeed';

export enum NewsfeedConfigurationKeys {
  isInstaLikeView = 'isInstaLikeView',
  isNewsfeedEnabled = 'newsfeed_enabled',
  includePresetsInFiltering = 'includePresetsInFiltering',
  EnableNewsfeedDelete = 'enable-newsfeed-delete',
  TransitionSpeed = 'transition-speed',
  AllowPinUnpinSpotlight = 'allow-pin-unpin-spotlight',
  ShowSpotlightScrollButtons = 'show-spotlight-scroll-buttons',
}

export enum PromoteConfigurationKeys {
  PromoteByAccountType = 'promoteByAccountType',
  PromoteByAccount = 'promoteByAccount',
  PromoteExpirationRangeDays = 'promoteExpirationRangeDays',
  PromoteExpiration = 'promoteExpiration',
  EnablePromotionWithSiteSubsite = 'enable-promotion-with-site-subsite',
  NeverExpirePossible = 'never-expire-possible',
}

export interface NewsfeedConfigurations
  extends IConfigurations<NewsfeedConfigurationKeys> {
  [NewsfeedConfigurationKeys.isInstaLikeView]: boolean;
  [NewsfeedConfigurationKeys.isNewsfeedEnabled]: boolean;
  [NewsfeedConfigurationKeys.includePresetsInFiltering]: boolean;
  [NewsfeedConfigurationKeys.EnableNewsfeedDelete]: boolean;
  [NewsfeedConfigurationKeys.TransitionSpeed]: string;
  [NewsfeedConfigurationKeys.AllowPinUnpinSpotlight]: boolean;
  [NewsfeedConfigurationKeys.ShowSpotlightScrollButtons]: boolean;
}

export interface PromoteConfigurations
  extends IConfigurations<PromoteConfigurationKeys> {
  [PromoteConfigurationKeys.PromoteByAccountType]: boolean;
  [PromoteConfigurationKeys.PromoteByAccount]: boolean;
  [PromoteConfigurationKeys.PromoteExpirationRangeDays]: number;
  [PromoteConfigurationKeys.PromoteExpiration]: boolean;
  [PromoteConfigurationKeys.EnablePromotionWithSiteSubsite]: boolean;
  [PromoteConfigurationKeys.NeverExpirePossible]: boolean;
}

export const NEWSFEED_CONFIGURATIONS_DEFAULT_VALUES: NewsfeedConfigurations = {
  [NewsfeedConfigurationKeys.isInstaLikeView]: false,
  [NewsfeedConfigurationKeys.isNewsfeedEnabled]: false,
  [NewsfeedConfigurationKeys.includePresetsInFiltering]: false,
  [NewsfeedConfigurationKeys.EnableNewsfeedDelete]: false,
  [NewsfeedConfigurationKeys.TransitionSpeed]: '0',
  [NewsfeedConfigurationKeys.AllowPinUnpinSpotlight]: false,
  [NewsfeedConfigurationKeys.ShowSpotlightScrollButtons]: false,
};
